
export const URL_BACK_TO_GESCOM = 'http://localhost:4200';

import { environment } from '../environments/environment';

// MODE DE DEMARAGE
export const START_MODE = {
  DEV: 'dev',
  PROD: 'prod',
  CLOUD: 'cloud'
};
/**
 * Construit une URL en fonction des paramètres donnés
 * @param {string | number} basePort - Le port du service
 * @param {string} path - Le chemin API spécifique (optionnel)
 * @returns {string} - L'URL complète générée
 */
function constructUrl(basePort: string | number, path: string = ''): string {
  // return environment.startMode === 'dev'
  //   // ? `https://korem.orders.aurorecloudxds.com${path}`
  //   ? `https://eric123456.orders.aurorecloudxds.com${path}`
  //   : environment.startMode === 'cloud'
  //     ? `${location.origin}${path}`
  //     : `${environment.protocol}${location.hostname}:${basePort}${path}`;
  return environment.startMode === START_MODE.DEV
    ? `${environment.protocol}${environment.host}:${basePort}${path}`
    : environment.startMode === START_MODE.CLOUD
      ? `${location.origin}${path}`
      : `${environment.protocol}${location.hostname}:${basePort}${path}`;
}

export const TYPE_TERMINAL = 'WEB';
// Extraction du tenantID si disponible dans l'URL
const hostname = location.hostname;
const parts = hostname.split('.');


function getModuleUrl(moduleName: string): string {
  if (environment.startMode === START_MODE.CLOUD) {
    switch (moduleName) {
      case 'gescom':
        return `${environment.protocol}${parts[0]}.${environment.services.gescom}`;
      case 'admin':
        return `${environment.protocol}${environment.services.admin}`;
      case 'compta':
        return `${environment.protocol}${parts[0]}.${environment.services.compta}`;
      case 'societe':
        return `${environment.protocol}${parts[0]}.${environment.services.societe}`;
      case 'mobile':
        return `${environment.protocol}${parts[0]}.${environment.services.mobile}`;
      case 'paie':
        return `${environment.protocol}${parts[0]}.${environment.services.paie}`;
      case 'pos':
        return `${environment.protocol}${parts[0]}.${environment.services.pos}`;
      default:
        throw new Error(`Module "${moduleName}" non reconnu.`);
    }
  }
  if (environment.startMode === START_MODE.DEV) {
    switch (moduleName) {
      case 'gescom':
        return `${environment.services.gescom}`;
      case 'admin':
        return `${environment.services.admin}`;
      case 'compta':
        return `${environment.services.compta}`;
      case 'societe':
        return `${environment.services.societe}`;
      case 'mobile':
        return `${environment.services.mobile}`;
      case 'paie':
        return `${environment.services.paie}`;
      case 'pos':
        return `${environment.services.pos}`;
      default:
        throw new Error(`Module "${moduleName}" non reconnu.`);
    }
  } else {
    switch (moduleName) {
      case 'gescom':
        return `${environment.protocol}${location.hostname}:${environment.services.gescom}`;
      case 'admin':
        return `${environment.protocol}${location.hostname}:${environment.services.admin}`;
      case 'compta':
        return `${environment.protocol}${location.hostname}:${environment.services.compta}`;
      case 'societe':
        return `${environment.protocol}${location.hostname}:${environment.services.societe}`;
      case 'mobile':
        return `${environment.protocol}${location.hostname}:${environment.services.mobile}`;
      case 'paie':
        return `${environment.protocol}${location.hostname}:${environment.services.paie}`;
      case 'pos':
        return `${environment.protocol}${location.hostname}:${environment.services.pos}`;
      default:
        throw new Error(`Module "${moduleName}" non reconnu.`);
    }
  }
}


// Définition des constantes de l'application
export const CODE_SITE_CENTRALE = 'PORTAIL';

// Définition des logos
export const LOGO_APP = environment.logos.app;


// Définition des URLs principales
export const BASE_URL = constructUrl(environment.port, `/api/${environment.station}/${environment.module}/mobile`);
export const BASE_URL_GESCOM_V1 = constructUrl(environment.port, `/api/${environment.station}/gescom/v1`);
export const BASE_URL_API = constructUrl(environment.port, `/api/${environment.station}/${environment.module}/v1`);
export const BASE_URL_API_MOBILE = constructUrl(environment.port, `/api/${environment.station}/${environment.module}`);
export const BASE_URL_REPORT = constructUrl(environment.port, `/api/${environment.station}/etat/v1`);
export const BASE_URL_AUTH = constructUrl(environment.port, `/api/${environment.station}/auth/v1`);


// Définition des URLs des services
export const BASE_URL_GESCOM = getModuleUrl('gescom');
export const BASE_URL_COMPTA = getModuleUrl('compta');
export const BASE_URL_POS = getModuleUrl('pos');
export const BASE_URL_ADMIN = getModuleUrl('admin');
export const BASE_URL_PRM_SOCIETE = getModuleUrl('societe');
export const BASE_URL_MOBILE = getModuleUrl('mobile');


/**
 * WELCOME_VIEW — Menu principal de l'application Mobile.
 *
 * Structure modulaire inspirée du projet COMPTA/frontend :
 *  - Chaque entrée de `content` est un module/groupe (ex: Structure, Traitement).
 *  - Chaque module possède un tableau `children` contenant les pages accessibles.
 *  - La NavBar génère un menu déroulant (d-menu Metro4) par module.
 *  - La page d'accueil (WelcomeComponent) affiche les cartes groupées par module.
 *
 * Pour ajouter un item dans un module : ajouter une entrée dans `children`.
 * Pour créer un nouveau module    : ajouter un objet dans `content`.
 */
export const WELCOME_VIEW = [
  {
    id: 1,
    title: 'APP_MOBILE',
    separator: false,
    content: [

      // ── MODULE STRUCTURE ──────────────────────────────────────────────────
      // Contient tous les menus de paramétrage et de gestion des données maîtres.
      {
        id: 10,
        libelle: 'NAVBAR.structure',
        icon: 'mif-bookmark',
        separator: false,
        children: [
          { id: 1, url: '/mobilite/gestion-utilisateurs', icon: 'mif-users',      libelle: 'Utilisateurs',    idObject: '30276' },
          { id: 2, url: '/mobilite/reclamations',         icon: 'mif-bubbles',    libelle: 'Réclamations',    idObject: '30277' },
          { id: 3, url: '/mobilite/bon-de-commandes',     icon: 'mif-file-text',  libelle: 'Bon de commandes', idObject: '30278' },
          { id: 4, url: '/mobilite/reglements',           icon: 'mif-calculator', libelle: 'Règlements',      idObject: '30279' },
          // { id: 5, url: '/mobilite/geolocalisation',      icon: 'mif-map',        libelle: 'Géolocalisation', idObject: '30280' },
          { id: 6, url: '/mobilite/structure/config-generale-tournee',
            icon: 'mif-map',        libelle: 'Configuration Générale du Module Tournées', idObject: '30281' },
          {
            id: 7,
            icon: 'mif-cog',
            libelle: 'STRUCT.CONFIGURATION',
            idObject: '30281',
            subMenu: true,
            children: [
              { id: 1, url: '/mobilite/structure/config/prochaine_action',
                icon: 'mif-rocket', libelle: 'PA.MENU', idObject: '30282' },
              { id: 2, url: '/mobilite/structure/config/client-geolocalise',
                icon: 'mif-map', libelle: 'Client géolocalisé', idObject: '30283' }
            ]
          },
          { id: 8, url: '/mobilite/structure/gestion-tournee',
            icon: 'mif-road', libelle: 'TOURNEE.TITLE', idObject: '30284' }
        ]
      },

      // ── MODULE TRAITEMENT ─────────────────────────────────────────────────
      // Réservé aux opérations et traitements métier à venir.
      // Ajouter ici les futurs items de traitement (ex: validation, clôture, ...).
      {
        id: 20,
        libelle: 'NAVBAR.traitement',
        icon: 'mif-cog',
        separator: false,
        children: [
          { id: 1, url: '/mobilite/traitement/suivi-commerciaux-gps-temps-reel',
            icon: 'mif-users', libelle: 'Suivi des commerciaux',    idObject: '30284' },
        ]
      }

    ]
  }
];

